/* jshint esversion: 6 */
import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router';
import CommonRouter from 'app/components/Routers/CommonRouter.jsx';
import App from 'app/components/common/App.jsx';
const Share = lazy(() => import(/* webpackChunkName: "Share" */ 'app/views/Share.jsx'));
import Automate from 'app/views/Share/Automate.jsx';
import AutomationTiles from 'app/views/Share/AutomationTiles.jsx';
import AutomateRouter from 'app/views/Share/AutomateRouter.jsx';
import RouteNew from 'app/views/Share/RouteNew.jsx';
import InputNew from 'app/views/Share/InputNew.jsx';
import AccountView from 'app/views/AccountView.jsx';
import People from 'app/views/People.jsx';
const ContentImport = lazy(() => import(/* webpackChunkName: "ContentImport" */ 'app/views/ContentImport.jsx'));
import Post from 'app/views/Content/Post.jsx';
import Features from 'app/views/Features.jsx';

import InputEdit from 'app/views/Share/InputEdit.jsx';
import InputDetailPanel from 'app/components/EditorComponents/InputDetailPanel.jsx';
import InputFilterPanel from 'app/components/EditorComponents/InputFilterPanel.jsx';
import InputTextPanel from 'app/components/EditorComponents/InputTextPanel.jsx';
import InputLocationPanel from 'app/components/EditorComponents/InputLocationPanel.jsx';
import InputAdvancedPanel from 'app/components/EditorComponents/InputAdvancedPanel.jsx';
import InputUpdatePanel from 'app/components/EditorComponents/InputUpdatePanel.jsx';
import FeedConfigurePanel from 'app/components/EditorComponents/FeedConfigurePanel.jsx';
import InputLogPanel from 'app/components/EditorComponents/InputLogPanel.jsx';
import InputHashtagPanel from 'app/components/EditorComponents/InputHashtagPanel.jsx';

import RouteSettings from 'app/views/Share/RouteSettings.jsx';
import RouteDetailPanel from 'app/components/EditorComponents/RouteDetailPanel.jsx';
import RouteFilterPanel from 'app/components/EditorComponents/RouteFilterPanel.jsx';
import RouteShortenersPanel from 'app/components/EditorComponents/RouteShortenersPanel.jsx';
import RouteTrackingPanel from 'app/components/EditorComponents/RouteTrackingPanel.jsx';

import CurateRouter from 'app/views/Share/CurateRouter.jsx';
import CurateItems from 'app/views/Share/CurateItems.jsx';
import CurateFeedsList from 'app/views/Share/CurateFeedsList.jsx';
import CurateFeedsNew from 'app/views/Share/CurateFeedsNew.jsx';
import Curate from 'app/views/Share/CurateFeedsList.jsx';
import CurateLogView from 'app/components/Curate/CurateLogView.jsx';
const Queue = lazy(() => import(/* webpackChunkName: "Queue" */ 'app/views/Queue.jsx'));
import QueueDetail from 'app/views/Share/QueueDetail.jsx';
import QueueSchedule from 'app/views/Share/QueueSchedule.jsx';
import CategoryManager from 'app/components/Queue/CategoryManager.jsx';
import CalendarView from 'app/components/Queue/CalendarView.jsx';
const Stats = lazy(() => import(/* webpackChunkName: "Stats" */ 'app/views/Stats.jsx'));
const Settings = lazy(() => import(/* webpackChunkName: "Settings" */ 'app/views/Settings.jsx'));
import Account from 'app/views/Settings/Account.jsx';
import ShortenerConfig from 'app/views/Settings/Shorteners.jsx';
import Users from 'app/views/People/Users.jsx';
import Clients from 'app/views/People/Clients.jsx';

import Importer from 'app/views/Content/Importer.jsx';
import CSVImporter from 'app/views/Content/CSVImporter.jsx';
import ContentRouter from 'app/views/Content/ContentRouter.jsx';
import Connections from 'app/views/Content/Connections.jsx';

import OutputConfigModal from 'app/components/OutputConfigModal/OutputConfigModal.jsx';
import SocialConfig from 'app/views/Settings/SocialConfig.jsx';
import SocialEditor from 'app/views/Settings/SocialEditor.jsx';
import SocialEditorPanel from 'app/components/EditorComponents/SocialPanels/SocialEditorPanel.jsx';
import SocialLogPanel from 'app/components/EditorComponents/SocialLogPanel.jsx';
import SubaccountSelector from 'app/views/Settings/SubaccountSelector.jsx';
import PostingGroups from 'app/views/Settings/PostingGroups.jsx';

import SubscriptionNew from 'app/views/SubscriptionNew.jsx';
import Subscription from 'app/views/Settings/Subscription.jsx';
import BillingInfo from 'app/views/Settings/BillingInfo.jsx';
import PaymentHistory from 'app/views/Settings/PaymentHistory.jsx';

import EverqueueItems from 'app/components/Everqueue/EverqueueItems.jsx';
import EverqueueSettings from 'app/components/Everqueue/EverqueueSettings.jsx';

import Welcome from 'app/views/Onboarding/Welcome.jsx';
import OnboardingSocials from 'app/views/Onboarding/OnboardingSocials.jsx';
import ActionChooser from 'app/views/Onboarding/ActionChooser.jsx';
import RouterError from 'app/components/Routers/RouterError.jsx';
import Loading from 'app/components/common/Loading.jsx';

import PromoLanding from 'app/views/PromoLanding.jsx';

export default function DlvrRouter() {
    let routes = (
        <Route element={<App/>} errorElement={<RouterError/>}>
            <Route path="/" element={<Navigate to="/share/automate"/>}/>
    		<Route path="content" element={<Suspense fallback={<Loading/>}><ContentImport/></Suspense>}>
				<Route path="feed" element={<ContentRouter/>}>
					<Route index element={<RouteNew/>} />
					<Route path="new/inputs" element={<RouteNew/>} />
					<Route path="new/configure" element={<RouteNew/>}/>
					<Route path="new/configure/input" element={<RouteNew/>}>
						<Route index element={<FeedConfigurePanel/>} />
						<Route path="setup" element={<FeedConfigurePanel/>} />
						<Route path="detail" element={<InputDetailPanel/>} />
						<Route path="update" element={<InputUpdatePanel/>} />
						<Route path="hashtags" element={<InputHashtagPanel/>} />
						<Route path="text" element={<InputTextPanel/>} />
						<Route path="filter" element={<InputFilterPanel/>} />
						<Route path="location" element={<InputLocationPanel/>} />
						<Route path="advanced" element={<InputAdvancedPanel/>} />
					</Route>
					<Route path="new/outputs" element={<RouteNew/>} />
					<Route path="detail/:routeId/input/new" element={<InputNew/>} />
					<Route path="detail/:routeId/input/new/configure" element={<InputNew/>}>
						<Route index element={<FeedConfigurePanel/>}/>
						<Route path="setup" element={<FeedConfigurePanel/>} />
						<Route path="detail" element={<InputDetailPanel/>} />
						<Route path="update" element={<InputUpdatePanel/>} />
						<Route path="hashtags" element={<InputHashtagPanel/>} />
						<Route path="text" element={<InputTextPanel/>} />
						<Route path="filter" element={<InputFilterPanel/>} />
						<Route path="location" element={<InputLocationPanel/>} />
						<Route path="advanced" element={<InputAdvancedPanel/>} />
					</Route>
				</Route>
                <Route path="post" element={<Post/>}/>
    			<Route path="import" element={<Importer/>}/>
    			<Route path="import/wordpress/:id" element={<Importer/>}/>
    			<Route path="csv" element={<CSVImporter/>}/>
    			<Route path="connections" element={<Connections/>}/>
    		</Route>
    		<Route path="share" element={<Suspense fallback={<Loading/>}><Share/></Suspense>}>
				<Route path="automations" element={<AutomationTiles/>} />
    			<Route path="getstarted" element={<OnboardingSocials/>}/>
    			<Route path="getstarted/chooser" element={<ActionChooser/>}/>
    			<Route path="automate" element={<AutomateRouter/>}>
                    <Route index element={<Automate/>}/>
    				<Route path="detail/:routeId" element={<Automate/>} />
    				<Route path="settings/:routeId" element={<RouteSettings/>}>
                        <Route index element={<RouteDetailPanel/>}/>
    					<Route path="detail" element={<RouteDetailPanel/>} />
    					<Route path="filters" element={<RouteFilterPanel/>} />
    					<Route path="tracking" element={<RouteTrackingPanel/>} />
    					<Route path="shorteners" element={<RouteShortenersPanel/>} />
    				</Route>
    				<Route path="new/inputs" element={<RouteNew/>} />
					<Route path="new/inputs/:inputType" element={<RouteNew/>} />
    				<Route path="new/configure" element={<RouteNew/>}/>
    				<Route path="new/configure/input" element={<RouteNew/>}>
                        <Route index element={<FeedConfigurePanel/>}/>
    					<Route path="setup" element={<FeedConfigurePanel/>}/>
    					<Route path="detail" element={<InputDetailPanel/>} />
    					<Route path="update" element={<InputUpdatePanel/>} />
    					<Route path="hashtags" element={<InputHashtagPanel/>} />
    					<Route path="text" element={<InputTextPanel/>} />
    					<Route path="filter" element={<InputFilterPanel/>} />
    					<Route path="location" element={<InputLocationPanel/>} />
    					<Route path="advanced" element={<InputAdvancedPanel/>} />
    				</Route>
    				<Route path="new/outputs" element={<RouteNew/>} />
    				<Route path="detail/:routeId/input/new" element={<InputNew/>} />
    				<Route path="detail/:routeId/input/new/configure" element={<InputNew/>}>
                        <Route index element={<FeedConfigurePanel/>} />
    					<Route path="setup" element={<FeedConfigurePanel/>} />
    					<Route path="detail" element={<InputDetailPanel/>} />
    					<Route path="update" element={<InputUpdatePanel/>} />
    					<Route path="hashtags" element={<InputHashtagPanel/>} />
    					<Route path="text" element={<InputTextPanel/>} />
    					<Route path="filter" element={<InputFilterPanel/>} />
    					<Route path="location" element={<InputLocationPanel/>} />
    					<Route path="advanced" element={<InputAdvancedPanel/>} />
    				</Route>
    				<Route path="detail/:routeId/input/:inputId" element={<InputEdit/>}>
                        <Route index element={<InputDetailPanel/>}/>
                        <Route path="detail" element={<InputDetailPanel/>} />
    					<Route path="update" element={<InputUpdatePanel/>} />
    					<Route path="hashtags" element={<InputHashtagPanel/>} />
    					<Route path="text" element={<InputTextPanel/>} />
    					<Route path="filter" element={<InputFilterPanel/>} />
    					<Route path="location" element={<InputLocationPanel/>} />
    					<Route path="advanced" element={<InputAdvancedPanel/>} />
    					<Route path="status" element={<InputLogPanel/>} />
    				</Route>
    			</Route>
                <Route path="curate" element={<CurateRouter/>}>
                    <Route index element={<CurateItems/>} />
                    <Route path="items" element={<CurateItems/>} />
                    <Route path="feeds/list" element={<CurateFeedsList/>} />
                    <Route path="feeds/detail/:inputId" element={<CurateFeedsList/>} />
                    <Route path="feeds/new" element={<CurateFeedsNew/>} />
                    <Route path="feeds/new/configure" element={<CurateFeedsNew/>} />
                    <Route path="feeds/log/:inputId" element={<CurateLogView/>} />
                </Route>
    		</Route>
    		<Route path="queue" element={<Suspense fallback={<Loading/>}><Queue/></Suspense>}>
    			<Route path="detail/:socialId" element={<QueueDetail/>} />
				<Route path="calendar/:socialId" element={<CalendarView/>} />
    			<Route path="schedule/:socialId" element={<QueueSchedule/>} />
    			<Route path="everqueue/:socialId" element={<EverqueueItems/>}/>
    			<Route path="everqueue/:socialId/settings" element={<EverqueueSettings/>}/>
    			<Route path="categories" element={<CategoryManager/>}/>

    		</Route>
    		<Route path="stats" element={<Suspense fallback={<Loading/>}><Stats/></Suspense>}>
    			<Route path="social" element={<Stats/>} />
    			<Route path="route" element={<Stats/>} />
    			<Route path="social/:socialId" element={<Stats/>} />
    			<Route path="route/:routeId" element={<Stats/>} />
				<Route path="all" element={<Stats/>} />
				<Route path="analyzer" element={<Stats/>} />
				<Route path="analyzer/:socialId" element={<Stats/>} />
    		</Route>
    		<Route path="config" element={<Suspense fallback={<Loading/>}><Settings/></Suspense>}>
    			<Route path="socials" element={<SocialConfig/>}>
    				<Route path="detail/:socialId" element={<SocialConfig/>}/>
    			</Route>
    			<Route path="social/:socialId" element={<SocialEditor/>}>
                    <Route index element={<SocialEditorPanel/>}/>
    				<Route path="options" element={<SocialEditorPanel/>}/>
    				<Route path="links" element={<SocialEditorPanel/>}/>
    				<Route path="advanced" element={<SocialEditorPanel/>}/>
    				<Route path="log" element={<SocialLogPanel/>}/>
    			</Route>
    			<Route path="shorteners" element={<ShortenerConfig/>}>
    				<Route path="detail/:type/:shortenerId" element={<ShortenerConfig/>}/>
    				<Route path="new" element={<ShortenerConfig/>}/>
    			</Route>
    			<Route path="chooser" element={<SubaccountSelector/>}/>
                <Route path="postgroups" element={<PostingGroups/>}/>
    		</Route>
    		<Route path="people" element={<People/>}>
    			<Route path="team" element={<Users/>}>
    				<Route path="new" element={<Users/>} />
    				<Route path="detail/:subaccountId" element={<Users/>} />
    			</Route>
    			<Route path="clients" element={<Clients/>}>
    				<Route path="new" element={<Clients/>} />
    				<Route path="detail/:subaccountId" element={<Clients/>} />
    			</Route>
    		</Route>
    		<Route path="account" element={<AccountView/>}>
                <Route index element={<Account/>} />
    			<Route path="detail" element={<Account/>} />
    			<Route path="subscription/new" element={<SubscriptionNew/>}>
    				<Route path="compare" element={<SubscriptionNew/>} />
    			</Route>
    			<Route path="subscription" element={<Subscription/>}>
    				<Route path="compare" element={<Subscription/>} />
    				<Route path="plus" element={<Subscription/>} />
    			</Route>
    			<Route path="billing" element={<BillingInfo/>}/>
    			<Route path="invoices" element={<PaymentHistory/>}/>
    		</Route>
			<Route path="promo" element={<PromoLanding/>}/>
			<Route path="welcome" element={<Welcome/>}/>
    	</Route>
    );

    return (
        <CommonRouter routes={routes}/>
    );
}
